import React, { useState } from "react";
import "../../styles/lab.css";

const classroomImages = [
  { id: 1, src: "/images/courses/class2.jpg", alt: "Classroom Image 1" },
  { id: 2, src: "/images/courses/class1.jpg", alt: "Classroom Image 2" },
];

const labSections = [
  {
    id: 1,
    title: "Computer Science and Engineering",
    description: "Programming Lab, Networking Lab, Data Structures Lab",
    images: [{ id: 3, src: "/images/courses/cslab.jpg", alt: "Computer Lab" }],
  },
  {
    id: 2,
    title: "Electronics and Communication",
    description: "Analog Lab, Digital Lab, Communication Systems Lab",
    images: [{ id: 4, src: "/images/courses/ec.jpg", alt: "Electronics Lab" }],
  },
  {
    id: 3,
    title: "Electrical and Electronics",
    description: "Electrical Machines Lab, Power Electronics Lab",
    images: [{ id: 5, src: "/images/courses/ee.jpg", alt: "Electrical Lab" }],
  },
  {
    id: 4,
    title: "Mechanical Engineering",
    description: "Thermal Lab, CAD/CAM Lab, Machine Shop",
    images: [{ id: 6, src: "/images/courses/me.jpg", alt: "Mechanical Workshop" }],
  },
  {
    id: 5,
    title: "Civil Engineering",
    description: "Survey Lab, Material Testing Lab, Environmental Lab",
    images: [{ id: 7, src: "/images/courses/ce.jpg", alt: "Civil Lab" }],
  },
  
];

const ClassroomsLabsGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="lab-and-classroom-container">
      {/* Classrooms */}
      <div className="classroom-section">
        <h1 className="section-title">CLASSROOMS</h1>
        <div className="yellow-line1"></div>
        <p className="justified">
          Our classrooms are well-ventilated, spacious, and equipped with modern teaching aids.
          Interactive boards, comfortable seating, and structured layouts ensure a positive
          learning environment for all students.
        </p>
        <div className="classroom-grid">
          {classroomImages.map((image) => (
            <img
              key={image.id}
              src={image.src}
              alt={image.alt}
              onClick={() => setSelectedImage(image)}
            />
          ))}
        </div>
      </div>

      {/* Labs */}
      <div className="lab-section-wrapper">
        <h1 className="section-title">DEPARTMENT LABS</h1>
        <div className="lab-grid">
          {labSections.map((section) => (
            <div key={section.id} className="lab-item-section">
              <h3>{section.title}</h3>
              <p className="justified">{section.description}</p>
              {section.images.length > 0 && (
                <img
                  src={section.images[0].src}
                  alt={section.images[0].alt}
                  onClick={() => setSelectedImage(section.images[0])}
                />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
          <div className="modal-content">
            <img src={selectedImage.src} alt={selectedImage.alt} className="modal-image" />
            <span className="close-button" onClick={() => setSelectedImage(null)}>×</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClassroomsLabsGallery;
